import type {PayloadAction, WritableDraft} from '@reduxjs/toolkit';
import type {ExpressionV4, MetadataEditState} from '../types';
import {
  assertExpression,
  assertMetadata,
  replaceExpression,
  updateEditStatusOnEdit,
  updateExpressionExportProps,
} from '../functions';
import type {MetadataEditAction_ExpressionEdited} from '../metadataEditActionTypes';

export const metadataEditExpressionEditedReducer = (
  state: WritableDraft<MetadataEditState>,
  action: PayloadAction<ExpressionV4>,
) => {
  const originalAction: MetadataEditAction_ExpressionEdited = {
    type: 'METADATAEDIT_EXPRESSION_EDITED',
    payload: action.payload,
  };
  // Handles editing of expressions loaded from backend (saved expressions)
  const savedExpression = assertExpression(
    action.payload.id,
    state.savedMetadata,
    originalAction,
    'saved',
  );
  const currentMetadata = assertMetadata(
    state.metadata,
    originalAction,
    'edit',
  );
  const currentExpression = assertExpression(
    action.payload.id,
    state.metadata,
    originalAction,
    'edit',
  );

  const newExpression = {...currentExpression, ...action.payload};

  state.metadata = replaceExpression(newExpression, currentMetadata);
  state.editStatuses = updateEditStatusOnEdit(
    savedExpression,
    newExpression,
    state.editStatuses,
  );
  state.exports = updateExpressionExportProps(newExpression, state.exports);
};
